import { render, staticRenderFns } from "./kradiobutton.vue?vue&type=template&id=3d33cfea&scoped=true&"
import script from "./kradiobutton.vue?vue&type=script&lang=js&"
export * from "./kradiobutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33cfea",
  null
  
)

export default component.exports